import { Component, EventEmitter, Input, Output, SimpleChanges } from '@angular/core';
import { FormGroup, FormControl, Validators, ReactiveFormsModule } from '@angular/forms';
import { AlertInfo } from '../../../../../models/alert-info';
import { SavedDataInfo } from '../../../../../models/form/saved-data-info';
import { AlertNotificationService } from '../../../../../services/alert-notification.service';
import { LawsService } from '../../../../../services/api/general-settings/laws.service';
import { FormService } from '../../../../../services/form.service';
import { ValidatorService } from '../../../../../services/validator.service';
import { NgbAlert } from '@ng-bootstrap/ng-bootstrap';
import { InputFieldComponent } from '../../../../../components/form/input-field/input-field.component';
import { SelectFieldComponent } from '../../../../../components/form/select-field/select-field.component';


@Component({
  selector: 'laws-form',
  imports: [NgbAlert, InputFieldComponent, SelectFieldComponent, ReactiveFormsModule],
  templateUrl: './laws-form.component.html',
  styleUrl: './laws-form.component.scss'
})
export class LawsFormComponent {
  @Input() law?: any;
  @Output() onSavedData = new EventEmitter<SavedDataInfo>();

  form!: FormGroup;

  alertInfo: AlertInfo = { show: false, type: '', message: '' };

  jurisdictionsOptions: { key: number; value: string }[] = [];

  constructor(
    private validatorService: ValidatorService,
    private formService: FormService,
    private alertNotificationService: AlertNotificationService,
    private lawsService: LawsService
  ) {
    this.lawsService.getJurisdictions().subscribe((jurisdictions: any) => {
      this.jurisdictionsOptions = jurisdictions.map((jurisdiction: any) => ({ key: jurisdiction.jurisdictionId, value: jurisdiction.name }));
    })
  }


  ngOnInit(): void {
    this.form = new FormGroup({
      jurisdictionId: new FormControl('', [Validators.required]),
      name: new FormControl('', [Validators.required]),
      validityStartDate: new FormControl(null,),
      validityEndDate: new FormControl(null,),
    });

  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['law'] && changes['law'].currentValue) {
      if (this.jurisdictionsOptions.length > 0) {
        this.form.patchValue({
          jurisdictionId: this.law.jurisdiction.jurisdictionId,
          name: this.law.name,
          validityStartDate: this.law.validityStartDate,
          validityEndDate: this.law.validityEndDate,
        });
      } else {
        this.lawsService.getJurisdictions().subscribe(() => {
          this.form.patchValue({
            jurisdictionId: this.law.jurisdiction.jurisdictionId,
            name: this.law.name,
            validityStartDate: this.law.validityStartDate,
            validityEndDate: this.law.validityEndDate,
          });
        });
      }
    }
  }

  /**
     * *******************
     * Submit form methods
     * *******************
     */
  showAlertInfo(type: string, message: string) {
    this.alertInfo = {
      show: true,
      type,
      message
    }
    window.scrollTo({ top: 0, behavior: 'smooth' });
    setTimeout(() => {
      this.alertInfo.show = false;
    }, 3000);
  }
  updateValidationErrors(validationErrors: any) {
    this.formService.resetErrors(this.form);
    this.formService.setValidationErrors(this.form, validationErrors);
  }
  submitFormSuccess(response: any) {
    this.alertNotificationService.success('Operation completed successfully')
    this.showAlertInfo('success', 'Operation completed successfully');

    this.onSavedData.emit({
      success: true,
      response
    });
  }
  submitFormError(error: any) {

    if (error.error.error.description == 'ARGUMENT_VALIDATION_ERROR') {
      this.updateValidationErrors(error.error.error.validationErrors);
    }
    else if (error.error.error.description == 'USER_EMAIL_ALREADY_EXISTS') {
      this.updateValidationErrors([{ field: 'email', defaultMessage: error.error.error.message }]);
      this.showAlertInfo('danger', `Please fix the error: ${error.error.error.message}`);
    }
    else {
      this.showAlertInfo('danger', error.error.error.message);
    }

    this.onSavedData.emit({
      success: false,
      error
    });

  }
  submitForm(): void {
    Object.keys(this.form.controls).forEach(key => {
      const control = this.form.get(key);
      control?.markAsTouched();
      control?.updateValueAndValidity();
    });   
     if (this.form.valid) {  
          const formValues = this.form.value;
      const processedValues = this.processEmptyValues(formValues, ['validityStartDate', 'validityEndDate']);

      const values = {
        ...processedValues,
        jurisdictionId: Number(formValues.jurisdictionId),
        tenantId: 1
      };

      this.alertInfo.show = false;
      this.formService.resetErrors(this.form);


      const serviceMethod = this.law ? this.lawsService.update(this.law.lawId, values) : this.lawsService.create(values);
      serviceMethod.subscribe({
        next: (response: any) => {
          this.submitFormSuccess(response)
        },
        error: (error: any) => {
          this.submitFormError(error)
        }
      })
    }
  }
  /**
   * *******************
   * Submit form methods
   * *******************
   */

  /**
   * Converte i valori vuoti in null per i campi specificati
   * @param formValues Valori del form da processare
   * @param fieldsToCheck Campi da controllare per valori vuoti
   * @returns Un oggetto con i valori processati
   */
  processEmptyValues(formValues: any, fieldsToCheck: string[]): any {
    const result = { ...formValues };
    
    fieldsToCheck.forEach(field => {
      if (result[field] === '') {
        result[field] = null;
      }
    });
    
    return result;
  }

  getLawJurisdictionsSelect(): FormControl { return this.getFormControl('jurisdictionId'); }
  getLawNameInput(): FormControl { return this.getFormControl('name'); }
  getLawStartDateInput(): FormControl { return this.getFormControl('validityStartDate'); }
  getLawEndDateInput(): FormControl { return this.getFormControl('validityEndDate'); }

  getFormControl(name: string): FormControl { return this.form.get(name) as FormControl; }
}
